import { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { FaUserCircle } from "react-icons/fa";
import { useTypeConfig } from "../../../utils/useTypeConfig";
import PermissionModal from "../PermissionModel";
import { useCommonContext } from "../../../utils/context";

const CustomerModal = ({ show, handleClose, user, fetchUser }) => {
  const { fetchCustomers: getCustomers } = useCommonContext();
  const { labels, hiddenFields } = useTypeConfig();
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [profileImage, setProfileImage] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProfileImage(file);
    setPreviewImage(URL.createObjectURL(file));
  };
  const [customerDetails, setCustomerDetails] = useState({
    customerName: "",
    companyName: "",
    mobileNo: "",
    emailId: "",
    customerType: "",
    brandNames: [""],
    modelNo: "",
    primaryAddress: "",
    landmarkPACI: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    region: "",
  });

  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setCustomerDetails({
      customerName: "",
      companyName: "",
      mobileNo: "",
      emailId: "",
      customerType: "",
      brandNames: [""],
      modelNo: "",
      primaryAddress: "",
      landmarkPACI: "",
      country: "",
      state: "",
      city: "",
      zipcode: "",
      region: "",
    });
    setErrors({});
  };

  useEffect(() => {
    if (user) {
      setCustomerDetails({
        customerName: user.customer_name || "",
        companyName: user.company_name || "",
        mobileNo: user.phone_number || "",
        emailId: user.email || "",
        brandNames: (user.brand_names || []).map((b) => b.name),
        modelNo: user.model_no || "",
        primaryAddress: user.primary_address || "",
        landmarkPACI: user.landmark_paci || "",
        country: user.country || "",
        state: user.state || "",
        city: user.city || "",
        zipcode: user.zipcode || "",
        region: user.region || "",
      });

      // ✅ ALWAYS prefer latest image
      const latestImage =
        localStorage.getItem("profile_image") || user.profile_image;

      setPreviewImage(latestImage || null);
      setProfileImage(null);
    } else {
      resetForm();
      setPreviewImage(null);
      setProfileImage(null);
    }
  }, [user, show]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setCustomerDetails((prev) => ({
      ...prev,
      [id]: value,
    }));

    if (id === "mobileNo" || id === "zipcode") {
      const numericValue = value.replace(/\D/g, "").replace(/^0+/, "");
      setCustomerDetails({ ...customerDetails, [id]: numericValue });
    } else {
      setCustomerDetails({ ...customerDetails, [id]: value });
    }

    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (user) {
    } else {
      if (!customerDetails.emailId.trim()) {
        newErrors.emailId = "Email is required.";
        valid = false;
      } else if (!/\S+@\S+\.\S+/.test(customerDetails.emailId)) {
        newErrors.emailId = "Email is invalid.";
        valid = false;
      }

      if (!customerDetails.mobileNo.trim()) {
        newErrors.mobileNo = "Mobile number is required.";
        valid = false;
      } else if (!/^\d{10}$/.test(customerDetails.mobileNo)) {
        newErrors.mobileNo = "Mobile number must be 10 digits.";
        valid = false;
      }
    }

    if (!customerDetails.customerName.trim()) {
      newErrors.customerName = "Name is required.";
      valid = false;
    }

    if (!customerDetails.primaryAddress.trim()) {
      newErrors.primaryAddress = "Address is required.";
      valid = false;
    }

    if (!customerDetails.landmarkPACI.trim()) {
      newErrors.landmarkPACI = "Landmark is required.";
      valid = false;
    }

    if (!customerDetails.country.trim()) {
      newErrors.country = "Country is required.";
      valid = false;
    }

    if (!customerDetails.state.trim()) {
      newErrors.state = "State is required.";
      valid = false;
    }

    if (!customerDetails.city.trim()) {
      newErrors.city = "City is required.";
      valid = false;
    }

    if (!customerDetails.zipcode.trim()) {
      newErrors.zipcode = "Zipcode is required.";
      valid = false;
    } else if (!/^\d{6}$/.test(customerDetails.zipcode)) {
      newErrors.zipcode = "Zipcode must be a 6-digit number.";
      valid = false;
    }

    if (!customerDetails.region.trim()) {
      newErrors.region = "Region is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const formData = new FormData();

    formData.append("email", customerDetails.emailId);
    formData.append("phone_number", customerDetails.mobileNo);
    formData.append("customer_name", customerDetails.customerName);
    formData.append("company_name", customerDetails.companyName);
    formData.append("model_no", customerDetails.modelNo);
    formData.append("customer_type", customerDetails.customerType);
    formData.append("primary_address", customerDetails.primaryAddress);
    formData.append("landmark_paci", customerDetails.landmarkPACI);
    formData.append("country", customerDetails.country);
    formData.append("state", customerDetails.state);
    formData.append("city", customerDetails.city);
    formData.append("zipcode", customerDetails.zipcode);
    formData.append("region", customerDetails.region);
    formData.append("role", "customer");

    // brand names
    // clear existing brand names
    formData.append("brand_names", "");

    customerDetails.brandNames
      .filter((name) => name.trim())
      .forEach((name) => {
        formData.append("brand_names", name.trim());
      });

    // permissions

    // ✅ image
    if (profileImage) {
      formData.append("profile_image", profileImage);
    }

    try {
      let response;

      const multipartHeaders = {
        ...HEADERS,
        "Content-Type": "multipart/form-data",
      };

      if (user) {
        response = await axios.put(
          `${BASE_URL}/users/tms_users/${user.id}/`,
          formData,
          { headers: multipartHeaders },
        );
      }

      if (response) {
        const updatedImage = response.data.profile_image;

        if (updatedImage) {
          setPreviewImage(updatedImage);
          localStorage.setItem("profile_image", updatedImage);
        }

        toast.success(`${labels.customer} updated successfully!`);

        handleClose();

        setTimeout(() => {
          getCustomers();
          fetchUser();
        }, 0);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const err = error.response.data;

        if (err.error) {
          const errorData = err.error;

          if (typeof errorData === "object" && !Array.isArray(errorData)) {
            Object.entries(errorData).forEach(([field, messages]) => {
              if (Array.isArray(messages)) {
                messages.forEach((msg) => toast.error(msg));
              } else {
                toast.error(messages);
              }
            });
          }

          return;
        }

        if (Array.isArray(err)) {
          err.forEach((msg) => toast.error(msg));
          return;
        }

        if (typeof err === "string") {
          toast.error(err);
          return;
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        resetForm();
        setPreviewImage(null);
        setProfileImage(null);
        setShowPermissionModal(false);
        handleClose();
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>User Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="text-center mb-3">
            <label htmlFor="profileImageUpload" style={{ cursor: "pointer" }}>
              {previewImage ? (
                <img
                  src={previewImage}
                  alt="Profile"
                  className="rounded-circle shadow-sm"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <FaUserCircle size={80} className="text-secondary" />
              )}
            </label>

            <input
              type="file"
              id="profileImageUpload"
              accept="image/*"
              hidden
              onChange={handleFileChange}
            />

            <div>
              <Button
                variant="outline-primary"
                size="sm"
                className="mt-2"
                onClick={() =>
                  document.getElementById("profileImageUpload").click()
                }
              >
                Upload Photo
              </Button>
            </div>
          </div>
          <Row className="mb-3">
            <Col>
              <Form.Group
                controlId="customerName"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder={labels.customerName}
                  value={customerDetails.customerName}
                  isInvalid={!!errors.customerName}
                  onChange={handleInputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.customerName}
                </Form.Control.Feedback>
                <Form.Label>{labels.customerName}*</Form.Label>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="mobileNo" className="form-floating ">
                <Form.Control
                  type="text"
                  placeholder="Mobile No."
                  value={customerDetails.mobileNo}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.mobileNo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobileNo}
                </Form.Control.Feedback>
                <Form.Label>Mobile No*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group controlId="emailId" className="form-floating mb-3">
                <Form.Control
                  type="email"
                  placeholder="Email Id"
                  value={customerDetails.emailId}
                  onChange={handleInputChange}
                  isInvalid={!!errors.emailId}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.emailId}
                </Form.Control.Feedback>
                <Form.Label>Email Id*</Form.Label>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group
                controlId="companyName"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder={labels.companyName}
                  value={customerDetails.companyName}
                  onChange={handleInputChange}
                  isInvalid={!!errors.companyName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.companyName}
                </Form.Control.Feedback>
                <Form.Label>{labels.companyName} </Form.Label>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            {!hiddenFields.includes("model") && (
              <Col>
                <Form.Group controlId="modelNo" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Model No"
                    value={customerDetails.modelNo}
                    onChange={handleInputChange}
                  />
                  <Form.Label>Model No</Form.Label>
                </Form.Group>
              </Col>
            )}
            <Col>
              <Form.Group controlId="region" className="form-floating mb-3">
                <Form.Select
                  value={customerDetails.region}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.region}
                >
                  <option value="" disabled>
                    Select Region
                  </option>
                  <option value="North">North</option>
                  <option value="West">West</option>
                  <option value="East">East</option>
                  <option value="South">South</option>
                </Form.Select>
                <Form.Label>Region*</Form.Label>

                <Form.Control.Feedback type="invalid">
                  {errors.region}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group
                controlId="primaryAddress"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Primary Address"
                  value={customerDetails.primaryAddress}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.primaryAddress}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.primaryAddress}
                </Form.Control.Feedback>
                <Form.Label>Address*</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group
                controlId="landmarkPACI"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Landmark / PACI"
                  value={customerDetails.landmarkPACI}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.landmarkPACI}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.landmarkPACI}
                </Form.Control.Feedback>
                <Form.Label>Landmark*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="city" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="City"
                  value={customerDetails.city}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.city}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.city}
                </Form.Control.Feedback>
                <Form.Label>City*</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="state" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="State"
                  value={customerDetails.state}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.state}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.state}
                </Form.Control.Feedback>
                <Form.Label>State*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="zipcode" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="Zip Code"
                  value={customerDetails.zipcode}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.zipcode}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.zipcode}
                </Form.Control.Feedback>
                <Form.Label>Zip Code*</Form.Label>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="country" className="form-floating mb-3">
                <Form.Control
                  type="text"
                  placeholder="Country"
                  value={customerDetails.country}
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.country}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.country}
                </Form.Control.Feedback>
                <Form.Label>Country*</Form.Label>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleFormSubmit} disabled={loading}>
          {loading ? (
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden"></span>
            </Spinner>
          ) : (
            "Update"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerModal;
